import axios from 'axios';
import Loader from 'react-loader-spinner';
import MDEditor from '@uiw/react-md-editor';
import { Link, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import BlogSidebar from '../BlogSidebar';
import { formatDate } from '../../utils/moment.util';

import './style.css';

const BlogSingle = () => {
  const [post, setPost] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { slugId } = useParams();

  useEffect(() => {
    axios
      .get(`${baseUrl}/blog/slug/${slugId}`)
      .then((res) => {
        setPost(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoadingError(true);
        setLoading(false);
      });
  }, [baseUrl, slugId]);

  return (
    <section className="wpo-blog-single-section section-padding">
      <div className="container">
        {loading ? (
          <div className="loader-container">
            <Loader type="Oval" color="#d90404" height={80} width={80} />
          </div>
        ) : loadingError ? (
          <div className="text-center">
            <p>Could not fetch the blog post. Refresh or check back later.</p>
          </div>
        ) : (
          <div className="row">
            <div className="col col-lg-8 col-12">
              <div className="wpo-wpo-blog-content clearfix">
                <div className="post">
                  <div className="entry-media">
                    <img src={post.image} alt="" />
                  </div>
                  <ul className="entry-meta">
                    <li>
                      <Link to="/blog">
                        <img src={post.createdBy.image} alt="" /> By{' '}
                        {post.createdBy.username}
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog">
                        <i className="ti-calendar"></i>{' '}
                        {formatDate(post.createdAt, 'MMM DD, YYYY')}
                      </Link>
                    </li>
                  </ul>
                  <h2>{post.title}</h2>
                  <MDEditor.Markdown source={post.body} />
                </div>
                {post.tags.length ? (
                  <div className="tag-share clearfix">
                    <div className="tag">
                      <ul>
                        {post.tags.split(',').map((tag, index) => (
                          <li key={index}>
                            <Link to="/blog">{tag}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : null}
                <div className="author-box">
                  <div className="author-avatar">
                    <Link to="/blog" target="_blank">
                      <img src={post.createdBy.image} alt="" />{' '}
                    </Link>
                  </div>
                  <div className="author-content pb-5">
                    <Link to="/blog" className="author-name">
                      {post.createdBy.firstName} &nbsp;
                      {post.createdBy.lastName}
                    </Link>
                    <p>{post.createdBy.bio}</p>
                    {/* TODO: ALL AUTHOR POSTS - TO BE IMPLEMENTED LATER */}
                    {/* <div className='author-btn'>
                      <Link to={`/blog?author=${post.createdBy.username}`}>
                        All Posts From Author
                      </Link>
                    </div> */}
                  </div>
                </div>
                <div className="more-posts clearfix">
                  <div className="previous-post">
                    <Link to="/blog">
                      <span className="post-control-link">Back</span>
                    </Link>
                  </div>
                  {/* TODO: NEXT & PREV POST - TO BE IMPLEMENTED LATER */}
                  {/* <div className='previous-post'>
                    <Link to='/blog'>
                      <span className='post-control-link'>Previous</span>
                    </Link>
                  </div>
                  <div className='next-post'>
                    <Link to='/blog'>
                      <span className='post-control-link'>Next post</span>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
            <BlogSidebar />
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogSingle;
